import styled, { css } from 'styled-components';
import { always, cond, propEq } from 'ramda';
import { Carousel as CarouselComponent } from 'react-responsive-carousel';
import { reactCarouselStyles } from './chartCarousel.lib.styles';

import { TRANSPARENT, CHART_CAROUSEL_TITLE_COLOR, CHART_CAROUSEL_TAB_COLOR } from '../../utils/colors';
import { Svg } from '../charts/charts.styles';
import { Button } from '../cardCarousel/cardCarousel.styles';
import { ContentContainer } from '../layout/layout.styles';
import { media } from '../../utils/media';

export const Tab = styled.div`
  padding-bottom: 20px;
`;

export const TabsList = styled.div`
  display: flex;
`;

export const TabIndicator = styled.div`
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid ${TRANSPARENT};
  color: ${CHART_CAROUSEL_TAB_COLOR};
  margin-right: 18px;
  opacity: 0.6;
  cursor: pointer;

  ${cond([
    [
      propEq('selected', true),
      always(css`
        opacity: 1;
        border-color: ${CHART_CAROUSEL_TAB_COLOR};
      `),
    ],
  ])}
`;

export const Carousel = styled(CarouselComponent)`
  ${reactCarouselStyles}

  .carousel.carousel-slider {
    display: flex;
    flex-direction: column-reverse;
  }

  .slide-wrapper {
    overflow: visible;
  }

  .carousel .slide {
    background: ${TRANSPARENT};
  }

  .carousel-status {
    display: none;
  }

  .carousel .control-dots {
    position: static;
    margin: 0;
  }

  ${Svg} {
    position: static;
  }
`;

export const Header = styled(ContentContainer)`
  display: flex;
  margin-bottom: 15px;
  align-items: center;

  ${Button} circle {
    fill: ${({ theme }) => theme.background};
  }

  ${Button} path {
    stroke: ${({ theme }) => theme.color};
  }
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.33em;
  letter-spacing: 0.45px;
  flex: 1 auto;
  margin: 0 20px 0 0;
  text-transform: uppercase;
  color: ${CHART_CAROUSEL_TITLE_COLOR};

  ${media.desktop`
    font-size: 18px;
  `}
`;

export const Container = styled.div``;
